import { inject, observer } from 'mobx-react'

import { withRouterProps } from '../../../utils'
import { HelpIcon, TooltipText } from '../../../components'
import {
  RetiredTodayGroup,
  RetiredTodayRow,
  RetiredTodayCta,
  DesktopHelp,
  MobileLearnMore,
} from './styles'

/** Starts temporary spend-down modeling without permanently switching modes. */
const RetiredTodayButton = ({
  navigate,
  store: {
    getSurvivorPension,
    getSurvivorPensionOptions,
    config: { enableSpendDownModeling },
  },
}) => {
  const handleRetiredToday = async () => {
    enableSpendDownModeling()
    const [pensionOptions, pension] = await Promise.all([
      getSurvivorPensionOptions(),
      getSurvivorPension(),
    ])
    if ((pension?.pensionId ?? null) === null && pensionOptions?.length > 0) {
      return navigate('/welcome/pension-options', { state: { from: '/home' } })
    }
    return navigate('/spending')
  }

  return (
    <RetiredTodayGroup>
      <RetiredTodayRow>
        <RetiredTodayCta onClick={handleRetiredToday}>When I retire</RetiredTodayCta>
        <DesktopHelp>
          <HelpIcon size='medium' tooltip={TooltipText.whatIsSpendDownModeling()} />
        </DesktopHelp>
      </RetiredTodayRow>
      <MobileLearnMore>
        <HelpIcon
          size='small'
          reverse
          helpLabel='Learn more about withdrawal modeling'
          tooltip={TooltipText.whatIsSpendDownModeling()}
        />
      </MobileLearnMore>
    </RetiredTodayGroup>
  )
}

export default withRouterProps(inject('store')(observer(RetiredTodayButton)))
